import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const loc = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen paper-bg flex items-center justify-center">
        <Loader2 className="animate-spin text-[#8b2e3e]" size={28} />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/admin/login" state={{ from: loc }} replace />;
  }
  return children;
}
